<template>
  <div class="px-6 py-4">
    <div class="text-2xl font-semibold text-blue-900">
      {{ registration.reference }} - {{ registration.domain }} <span class="font-normal">(สถานะ: {{ getStatusName(registration.status) }})</span>
    </div>
    <div v-if="registration.remark" class="mt-4 text-red-500">
      <span class="mr-4 text-black underline">เหตุผลการปฏิเสธ</span>{{ registration.remark }}
    </div>
    <div class="text-lg font-semibold mt-4 mb-4">ข้อมูลภาษาไทย</div>
    <div class="grid grid-cols-12 gap-4">
      <template v-if="registration.type == 'C'">
        <div class="col-span-12 md:col-span-5">
          <breeze-label for="owner_firstname" value="ชื่อนิติบุคคล*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_firstname }}
          </div>
        </div>

        <div class="col-span-12 md:col-span-3">
          <breeze-label for="owner_title_code" value="ประเภท*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_title }}
          </div>
        </div>

        <div class="col-span-8 sm:col-span-2">
          <breeze-label for="owner_branch_name" value="ชื่อสาขา" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_branch_name }}
          </div>
        </div>

        <div class="col-span-4 sm:col-span-2">
          <breeze-label for="branch_no" value="สาขาที่" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.branch_no }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-span-4 md:col-span-3">
          <breeze-label
            for="owner_title_code"
            value="ชื่อผู้ประกอบการ (คำนำหน้า)*"
          />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_title }}
          </div>
        </div>

        <div class="col-span-8 md:col-span-3">
          <breeze-label
            for="owner_firstname"
            value="ชื่อผู้ประกอบการ (ชื่อ)*"
          />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_firstname }}
          </div>
        </div>

        <div class="col-span-12 md:col-span-3">
          <breeze-label
            for="owner_lastname"
            value="ชื่อผู้ประกอบการ (นามสกุล)*"
          />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_lastname }}
          </div>
        </div>
      </template>

      <div class="col-span-12 sm:col-span-3">
        <breeze-label
          for="tax_id"
          value="เลขประจำตัวผู้เสียภาษีอากร 13 หลัก*"
        />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.tax_id }}
        </div>
      </div>

      <div class="col-span-4 md:col-span-3">
        <breeze-label
          for="manager_title_code"
          value="ชื่อผู้ติดต่อ (คำนำหน้า)*"
        />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.manager_title }}
        </div>
      </div>

      <div class="col-span-8 md:col-span-3">
        <breeze-label for="manager_firstname" value="ชื่อผู้ติดต่อ (ชื่อ)*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.manager_firstname }}
        </div>
      </div>

      <div class="col-span-12 md:col-span-3">
        <breeze-label for="manager_lastname" value="ชื่อผู้ติดต่อ (นามสกุล)*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.manager_lastname }}
        </div>
      </div>

      <div v-if="registration.type == 'P'" class="col-span-12 md:col-span-3">
        <breeze-label for="company_name" value="ชื่อกิจการ/ร้านค้า*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.company_name }}
        </div>
      </div>
    </div>

    <div class="text-lg font-semibold mt-8 mb-4">ที่อยู่ภาษาไทย</div>
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-4 sm:col-span-2">
        <breeze-label for="house_no" value="เลขที่*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.house_no }}
        </div>
      </div>

      <div class="col-span-8 sm:col-span-3">
        <breeze-label for="building" value="อาคาร/หมู่บ้าน" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.building }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-1">
        <breeze-label for="floor" value="ชั้น" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.floor }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-1">
        <breeze-label for="moo" value="หมู่ที่" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.moo }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-2">
        <breeze-label for="soi" value="ซอย" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.soi }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label for="road" value="ถนน" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.road }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label for="province_code" value="จังหวัด*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.province_code }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label for="district_code" value="อำเภอ/เขต*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.district_code }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label for="sub_district_code" value="ตำบล/แขวง*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.sub_district_code }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label for="post_code" value="รหัสไปรษณีย์*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.post_code }}
        </div>
      </div>

      <div class="col-span-12 sm:col-span-3">
        <breeze-label for="email" value="อีเมล*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.email }}
        </div>
      </div>

      <div class="col-span-12 sm:col-span-3">
        <breeze-label for="telephone" value="เบอร์โทรศัพท์/เบอร์มือถือ*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.telephone }}
        </div>
      </div>
    </div>

    <div class="text-lg font-semibold mt-8 mb-4">ข้อมูลภาษาอังกฤษ</div>
    <div class="grid grid-cols-12 gap-4">
      <template v-if="registration.type == 'C'">
        <div class="col-span-12 md:col-span-5">
          <breeze-label for="owner_firstname_en" value="Company Name*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_firstname_en }}
          </div>
        </div>

        <div class="col-span-12 md:col-span-3">
          <breeze-label for="owner_title_en" value="Juristic Type*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_title_en }}
          </div>
        </div>

        <div class="col-span-8 sm:col-span-2">
          <breeze-label for="owner_branch_name_en" value="Branch Name" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_branch_name_en }}
          </div>
        </div>

        <div class="col-span-4 sm:col-span-2">
          <breeze-label for="branch_no" value="Branch No." />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.branch_no }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-span-12 md:col-span-3">
          <breeze-label for="owner_title_en" value="Owner (title)*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_title_en }}
          </div>
        </div>

        <div class="col-span-8 md:col-span-3">
          <breeze-label for="owner_firstname_en" value="Owner (firstname)*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_firstname_en }}
          </div>
        </div>

        <div class="col-span-12 md:col-span-3">
          <breeze-label for="owner_lastname_en" value="Owner (lastname)*" />
          <div
            class="
              mt-1
              px-3
              py-2
              h-10
              font-medium
              bg-blue-50
              border-gray-300
              rounded-md
              shadow-sm
              text-gray-700
            "
          >
            {{ registration.owner_lastname_en }}
          </div>
        </div>
      </template>

      <div class="col-span-12 sm:col-span-3">
        <breeze-label for="tax_id" value="Tax ID (13 Digits)*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.tax_id }}
        </div>
      </div>

      <div class="col-span-4 md:col-span-3">
        <breeze-label for="manager_title_en" value="Contact Person (title)*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.manager_title_en }}
        </div>
      </div>

      <div class="col-span-8 md:col-span-3">
        <breeze-label
          for="manager_firstname_en"
          value="Contact Person (firstname)*"
        />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.manager_firstname_en }}
        </div>
      </div>

      <div class="col-span-12 md:col-span-3">
        <breeze-label
          for="manager_lastname_en"
          value="Contact Person (lastname)*"
        />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.manager_lastname_en }}
        </div>
      </div>

      <div v-if="registration.type == 'P'" class="col-span-12 md:col-span-3">
        <breeze-label for="company_name_en" value="Business Name/Shop Name*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.company_name_en }}
        </div>
      </div>
    </div>

    <div class="text-lg font-semibold mt-8 mb-4">ที่อยู่ภาษาอังกฤษ</div>
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-4 sm:col-span-2">
        <breeze-label for="house_no_en" value="House No.*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.house_no_en }}
        </div>
      </div>

      <div class="col-span-8 sm:col-span-3">
        <breeze-label for="building_en" value="Building/Village" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.building_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-1">
        <breeze-label for="floor_en" value="Floor" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.floor_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-1">
        <breeze-label for="moo_en" value="Moo" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.moo_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-2">
        <breeze-label for="soi_en" value="Soi" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.soi_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label for="road_en" value="Road" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.road_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label value="Province*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.province_name_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label value="District*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.district_name_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label value="Sub District*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.sub_district_name_en }}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <breeze-label value="Postal Code*" />
        <div
          class="
            mt-1
            px-3
            py-2
            h-10
            font-medium
            bg-blue-50
            border-gray-300
            rounded-md
            shadow-sm
            text-gray-700
          "
        >
          {{ registration.post_code }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreezeLabel from "@/Components/Label";
import BreezeInput from "@/Components/Input";

export default {
  props: ["registration", "statuses"],
  components: {
    BreezeLabel,
    BreezeInput,
  },
  methods: {
    getStatusName(statusKey) {
      return _.find(this.statuses, status => status.value == statusKey).name;
    }
  },
};
</script>
